import { SearchLg } from '@untitled-ui/icons-react/build/cjs';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ButtonCmp from 'src/components/ButtonCmp';
import InputText from 'src/components/InputText/InputText';

interface IFilterLayoutProps {
    children?: React.ReactNode;
    isSaveBtn?: boolean;
    onSave?: () => void;
    onCancel: () => void;
    search: string;
    handleSearchChange: (event: any) => void;
    isSaveEnable?: boolean;
    isLoading?: boolean;
}

const FilterLayout = ({ children, isSaveBtn = false, onSave, onCancel, search, handleSearchChange, isSaveEnable, isLoading }: IFilterLayoutProps) => {
    const searchValue = search ?? '';
    const { t } = useTranslation();

    return (
        <div className="">
            <div className="table-header-filter-space border-b border-utilityGray200 flex gap-2">
                <InputText
                    inputName="searchDocument"
                    size="sm"
                    placeholder={t('Common.Search')}
                    className="bg-white focus:bg-white pl-8 pr-7 placeholder:text-gray500 shadow-sm font-normal search-input"
                    icon={<SearchLg className="absolute top-1/2 -translate-y-1/2 left-2 text-grayText h-4 w-4" />}
                    inputType="text"
                    value={searchValue}
                    onChangeFunc={handleSearchChange}
                    parentClassName="table-searchInput !flex-1"
                    isClearable={true}
                />

                <ButtonCmp type="button" onClick={onCancel} className="btn_secondary_black">
                    Cancel
                </ButtonCmp>
                {isSaveBtn && (
                    <ButtonCmp type="button" onClick={onSave} disabled={!isSaveEnable || isLoading} loading={isLoading} className="btn-outline-primary">
                        Save View
                    </ButtonCmp>
                )}
            </div>

            <div className="border-b border-utilityGray200 table-header-filter-space flex flex-wrap gap-2">{children}</div>
        </div>
    );
};

export default FilterLayout;
